import type { FlowScreenConfig } from "@/shared/constants/flowTypes";

import { AdminSignoffIntroScreen } from "../components/steps/AdminSignoffIntroScreen";
import { AdminSignoffLoopScreen, getAdminSignoffLoopState } from "../components/steps/AdminSignoffLoopScreen";

export function createAdminSignoffScreens(): FlowScreenConfig[] {
  return [
    {
      id: "admin_signoff_intro",
      layout: "full",
      customComponent: AdminSignoffIntroScreen,
      getButtonText: () => "Get started",
    },
    {
      id: "admin_signoff_loop",
      layout: "full",
      customComponent: AdminSignoffLoopScreen,
      hideButton: ({ answers }) => {
        const { loading, total } = getAdminSignoffLoopState(answers);
        return loading || total > 0;
      },
      getButtonText: () => "See your forms",
    },
  ];
}
